import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Span.styles';

const Span = ({ children, font, type, variant, weight, modifier }) => (
  <S.Span
    font={font}
    type={type}
    variant={variant}
    weight={weight}
    modifier={modifier}
  >
    {children}
  </S.Span>
);

Span.defaultProps = {
  font: 'primary',
  type: '1',
  variant: 'primary',
  weight: 'regular',
  modifier: 'regular',
};

Span.propTypes = {
  font: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary-1',
    'secondary-2',
    'secondary-3',
    'neutral',
    'neutral-1',
    'danger',
    'warning',
    'info',
    'success',
  ]).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted'])
    .isRequired,
};

export default Span;
